import script from "./CertificateRequestView.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificateRequestView.vue?vue&type=script&setup=true&lang=js"

import "./CertificateRequestView.vue?vue&type=style&index=0&id=685804c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-685804c2"]])

export default __exports__